<template>
  <generic-update-list
    v-bind="{ model, modelHeaders, modelFk, defaultItem, filters }"
    custom-export-url="/events/export/"
  >
    <template v-slot:form="{ editedItem, error }">
      <event-form v-bind="{ editedItem, error, modelFk }"></event-form>
    </template>

    <template v-slot:item.start_date="{ item }">
      {{ item.start_date.substring(0, 10) }}
    </template>

    <template v-slot:item.warnings="{ item }">
      <v-icon v-if="item.warnings.length > 0">
        fa fa-exclamation-triangle
      </v-icon>
    </template>
  </generic-update-list>
</template>

<script>
import models from "@/models"
import EventForm from "@/components/EventForm"

export default {
  components: { EventForm },
  data() {
    return {
      modelHeaders: [
        { text: "Codice", value: "code" },
        { text: "Titolo", value: "title" },
        { text: "Data inizio", value: "start_date" },
        { text: "Alert", value: "warnings" },
      ],
      model: models.Event,
      filters: [
        { name: "place", model: models.ShowPlace, text: "place__name" },
        { name: "people", model: models.ShowPerson, text: "person__name" },
        { name: "bands", model: models.ShowBand, text: "band__name" },
        {
          name: "concert__categories",
          model: models.ConcertCategory,
          text: "name",
        },
        {
          name: "kind",
          label: "Tipologia",
          values: [
            { id: 1, name: "Evento pubblico" },
            { id: 2, name: "Prova" },
            { id: 3, name: "Accordatura" },
          ],
        },
        {
          name: "price",
          label: "Prezzo",
          values: [
            { id: 1, name: "Libero" },
            { id: 2, name: "Biglietto museo" },
            { id: 3, name: "Pagamento" },
          ],
        },
        // {
        //   name: "concertCategories",
        //   model: models.ConcertCategory,
        //   text: "name",
        // },
      ],
    }
  },
  computed: {
    modelFk() {
      return { show: this.$route.params.id }
    },
  },
  methods: {
    defaultItem: () => ({
      code: "",
      title: "",
      concert: null,
      place: null,
      people: [],
      bands: [],
      instruments: [],
      sponsor: "",
      start_date: "",
      end_date: "",
      price: 1,
      kind: 1,
      notes: "",
    }),
  },
}
</script>
